import React from 'react';
import PropTypes from 'prop-types';
import Popup from 'components/Popup';
import Button from 'components/Buttons/Button';
import Loading from 'components/Loading';
import { literalTemplate } from 'utils/language';
import SectionHeader from 'components/SectionHeader';

const CARTA = 'carta';
const CAPDESK = 'capdesk';
const LEDGY = 'ledgy';

function PermissionsPopup({
  literals,
  platform,
  loading = null,
  request = null,
  onSubmit,
  onDelete,
  onClose,
}) {
  const handleSubmit = async (tab) => {
    onSubmit({
      service: 'import_captable',
      message: tab,
    });
  };

  const handleDelete = async () => {
    onDelete('import_captable');
  };

  const tabs = [
    { key: CARTA, name: CARTA.toUpperCase() },
    { key: CAPDESK, name: CAPDESK.toUpperCase() },
    { key: LEDGY, name: LEDGY.toUpperCase() },
  ];

  const renderTab = (tab) => {
    let navigate = '';
    switch (tab) {
      case CARTA:
        navigate = literals.importCaptable.navigateCarta;
        break;
      case CAPDESK:
        navigate = literals.importCaptable.navigateCapdesk;
        break;
      case LEDGY:
        navigate = literals.importCaptable.navigateLedgy;
        break;
      default:
    }
    return (
      <>
        <ol className='captable-import'>
          <li>{literalTemplate(literals.importCaptable.login, { PAGE: tab.toUpperCase() })}</li>
          <li>{navigate}</li>
          <li>{literals.importCaptable.addEmail}</li>
          <li>{literals.importCaptable.markCompleted}</li>
          <li>{literals.importCaptable.notification}</li>
        </ol>
        <div className='buttons mt-3'>
          <Button
            text={request ? literals.cancelRequest : literals.markCompleted}
            color={request ? 'danger' : 'primary'}
            onClick={request ? handleDelete : () => handleSubmit(tab)}
            loading={loading}
          />
        </div>
      </>
    );
  };

  return (
    <Popup title={literalTemplate(literals.invitePlatform, { PLATFORM: platform.name })} onClose={onClose}>
      <SectionHeader tabs={tabs}>
        {tab => (
          loading === 'fetching'
            ? <Loading mode='panel' />
            : renderTab(tab)
        )}
      </SectionHeader>
    </Popup>
  );
}

PermissionsPopup.propTypes = {
  platform: PropTypes.object.isRequired,
  literals: PropTypes.object.isRequired,
  request: PropTypes.object,
  loading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default PermissionsPopup;
